// extracted by mini-css-extract-plugin
module.exports = {"Root":"Empty_Root__1jq-A"};